/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */

export class AutoMapper {
  constructor() {
    if (AutoMapper.instance) {
      return AutoMapper.instance;
    }

    this.mappings = new Map();
    AutoMapper.instance = this;
  }

  static getInstance() {
    if (!AutoMapper.instance) {
      AutoMapper.instance = new AutoMapper();
    }
    return AutoMapper.instance;
  }

  createMap(sourceKey, destinationKey) {
    const map = new Map();
    this.mappings.set(`${sourceKey}_${destinationKey}`, map);
    return {
      forMember(destProp, mapFn) {
        map.set(destProp, mapFn);
        return this;
      },
    };
  }

  _setNestedProperty(obj, path, value) {
    const keys = path.split('.');
    let current = obj;
    while (keys.length > 1) {
      const key = keys.shift();
      if (!current[key]) {
        current[key] = {};
      }
      current = current[key];
    }
    current[keys[0]] = value;
  }

  map(source, sourceKey, destinationKey) {
    const map = this.mappings.get(`${sourceKey}_${destinationKey}`);
    if (!map) {
      throw new Error(`Mapping not found for ${sourceKey} to ${destinationKey}`);
    }

    const destination = {};
    map.forEach((mapFn, destProp) => {
      const value = mapFn(source);
      this._setNestedProperty(destination, destProp, value);
    });

    return destination;
  }

  async mapAsync(source, sourceKey, destinationKey) {
    const map = this.mappings.get(`${sourceKey}_${destinationKey}`);
    if (!map) {
      throw new Error(`Mapping not found for ${sourceKey} to ${destinationKey}`);
    }

    const destination = {};
    await Promise.all(
      Array.from(map.entries()).map(async ([destProp, mapFn]) => {
        let value = mapFn(source);
        if (value instanceof Promise) {
          value = await value;
        }
        this._setNestedProperty(destination, destProp, value);
      })
    );

    return destination;
  }
}
